// extracted by mini-css-extract-plugin
export default {"preview":"VideoPreview_preview__yGDhg"};